import React from "react";
import { motion } from "framer-motion";
import { hideAnimation, coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const CoursesDetail41 = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <div className="images">
        <img src={props.img} alt="" />
      </div>
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <h2>
          <span>詳細課程內容:</span>
        </h2>
        <p>
          在這堂課程當中，我們會學習各種電腦科學當中，使用JavaScipt這門程式語言，來了解並一步一步寫出各種實用的演算法與資料結構。資料結構與演算法為電腦科學系、資工系必修科目之一，也是所有電腦相關科系中最重要的課程之一，因為其概念應用廣泛，在現實生活中的軟體、網路應用與資料處理，都會大量使用到資料結構與演算法的概念。
        </p>
        <p>
          電腦世界中的資料以許多不同的形式儲存起來。當資料量開始的龐大時，好的演算法與資料結構可以大幅提升資料處存與讀取的速度。在建造系統時，不同的情況下會需要不同種類的資料結構。此課程會深入淺出的學習許多至種不同的資料結構，並且逐一分析使用情況與時機，並且了解其時間複雜度。
        </p>
      </motion.div>
    </div>
  );
};

export default CoursesDetail41;
